/**
 * @generated SignedSource<<941dc0fa4987ac5d9a91fb7e8f97205b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsIcon_viewer$data = {
  readonly userNotifications: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetAllUnviewedNotifications_userNotifications">;
  } | null;
  readonly " $fragmentType": "UserNotificationsIcon_viewer";
};
export type UserNotificationsIcon_viewer$key = {
  readonly " $data"?: UserNotificationsIcon_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsIcon_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showPriceDropNotifications"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserNotificationsIcon_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "showPriceDropNotifications",
          "variableName": "showPriceDropNotifications"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "UserNotifications",
      "kind": "LinkedField",
      "name": "userNotifications",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetAllUnviewedNotifications_userNotifications"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "084a89f6997476c1983710b8e1cb986a";

export default node;
